import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import {
  Button,
  ModalDialog,
} from '@openedx/paragon';

import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';
import messages from './messages';

const AgeConfirmationModal = ({ isModalOpen, userId }) => {
  const intl = useIntl();

  const [isOpen, setOpen] = useState(isModalOpen);
  const [isDecline, setIsDecline] = useState(false);
  const [isError, setIsError] = useState(false);

  const handleSubmit = async () => {
    await getAuthenticatedHttpClient()
      .patch(`${getConfig().LMS_BASE_URL}/user-extensions/api/extended-user-profile/${userId}/`, {
        confirm_age_consent: true,
      })
      .then(() => {
        setOpen(false);
      })
      .catch(() => {
        setIsError(true);
      });
  };

  const getModalBodyContent = () => {
    switch (true) {
      case isDecline:
        return <p>{intl.formatMessage(messages.declineMessage)}</p>;
      case isError:
        return <p className="text-danger">{intl.formatMessage(messages.errorMessage)}</p>;
      default:
        return <p>{intl.formatMessage(messages.description)}</p>;
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      setOpen(true);
    }
  }, [isModalOpen]);

  return (
    <ModalDialog
      title={intl.formatMessage(messages.title)}
      isOpen={isOpen}
      onClose={() => setOpen(false)}
      size="md"
      variant="default"
      hasCloseButton={false}
      isBlocking
    >
      <ModalDialog.Header>
        <ModalDialog.Title>
          {intl.formatMessage(messages.title)}
        </ModalDialog.Title>
      </ModalDialog.Header>
      <ModalDialog.Body>
        {getModalBodyContent()}
      </ModalDialog.Body>
      {!isDecline ? (
        <ModalDialog.Footer>
          <Button variant="danger" onClick={() => setIsDecline(true)}>
            {intl.formatMessage(messages.buttonDecline)}
          </Button>
          <Button variant="success" onClick={handleSubmit} className="ml-2">
            {intl.formatMessage(messages.buttonSubmit)}
          </Button>
        </ModalDialog.Footer>
      ) : null}
    </ModalDialog>
  );
};

AgeConfirmationModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  userId: PropTypes.number.isRequired,
};

export default AgeConfirmationModal;
